export const usersMock = [
  {
    _id: '62eeeaa2a174302d0a7d2e90',
    index: 0,
    guid: 'cf0c9d1a-aaf4-4b02-86c6-67f098429c08',
    picture: 'http://placehold.it/32x32',
    age: 26,
    name: 'Cooper Palmer',
  },
  {
    _id: '62eeeaa27eb9131e7b6f8684',
    index: 1,
    guid: '987e0475-f4b1-4390-9e92-06f653fbfce5',
    picture: 'http://placehold.it/32x32',
    age: 37,
    name: 'Adriana Guthrie',
  },
  {
    _id: '62eeeaa24eb1ad77f89e8ee7',
    index: 2,
    guid: '512e4f84-c344-4e50-96c8-93ec6eb727c5',
    picture: 'http://placehold.it/32x32',
    age: 33,
    name: 'Gena Hart',
  },
  {
    _id: '62eeeaa2667143241e8056d1',
    index: 3,
    guid: 'fe4bec2d-9073-4110-85e2-a16672bcfc8e',
    picture: 'http://placehold.it/32x32',
    age: 20,
    name: 'Tasha Lancaster',
  },
  {
    _id: '62eeeaa2518ffcd589c7c408',
    index: 4,
    guid: '8333fb55-8057-467f-93b1-622ed9f86d4b',
    picture: 'http://placehold.it/32x32',
    age: 20,
    name: 'Pearlie Foley',
  },
  {
    _id: '62eeeaa2dd4fac042c64b2b1',
    index: 5,
    guid: 'da6bae59-1625-4273-9800-4e1a87f69f0b',
    picture: 'http://placehold.it/32x32',
    age: 31,
    name: 'Burch Jacobson',
  },
];
